import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * operationMode:
 *   'auto'   — detecta automáticamente según el dispositivo (móvil/tablet → pasos, desktop → normal)
 *   'steps'  — siempre usa el modo por pasos (teclado táctil, wizard)
 *   'normal' — siempre usa el formulario clásico (teclado físico del sistema)
 */
export type OperationMode = 'auto' | 'steps' | 'normal';

interface SettingsState {
  operationMode: OperationMode;
}

const STORAGE_KEY = 'payplus_operation_mode';

const savedMode = localStorage.getItem(STORAGE_KEY) as OperationMode | null;

const initialState: SettingsState = {
  operationMode: savedMode && ['auto', 'steps', 'normal'].includes(savedMode)
    ? savedMode
    : 'auto',
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setOperationMode: (state, action: PayloadAction<OperationMode>) => {
      state.operationMode = action.payload;
      localStorage.setItem(STORAGE_KEY, action.payload);
    },
  },
});

export const { setOperationMode } = settingsSlice.actions;
export default settingsSlice.reducer;
